module.exports = "/virtual-football-league/img/amblems/left/logos/BrightHoveAlbion.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/BrightHoveAlbion.png
// module id = 2059
// module chunks = 4